import { usePostgresLayerWithTable } from "./usePostgresLayerWithTable";
import { useDialogInfo } from "../useDialogs";

export const useLayerFromDialog = () => {
  const { resources } = useDialogInfo(true);
  const layerName = resources && resources[0];

  return usePostgresLayerWithTable(layerName, true);
};
